export const baseURL = process.env.REACT_APP_THINQ_AUTH_SERVER_KIC;

export const headers = {
  Authorization: `Bearer ${process.env.REACT_APP_THINQ_TOKEN}`,
  'x-message-id': 'dxdWGBCpQ0St3s316PbqZg',
  'x-api-key': process.env.REACT_APP_THINQ_API_KEY,
  'x-country': 'KR',
  'Content-Type': 'application/json',
};
